/**
 * @generated SignedSource<<959e120259cd8956b3b8a9f865466998>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type assetPickerDialogAssets_query$data = {
  readonly aiAssetLibraryAssets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly categoryName: string | null;
        readonly fileUrl: string;
        readonly id: string;
        readonly name: string;
        readonly thumbnailUrl: string | null;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "assetPickerDialogAssets_query";
};
export type assetPickerDialogAssets_query$key = {
  readonly " $data"?: assetPickerDialogAssets_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"assetPickerDialogAssets_query">;
};

import assetPickerDialogAssetsPaginationQuery_graphql from './assetPickerDialogAssetsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "aiAssetLibraryAssets"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "assetType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "categoryID"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sortBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sortDirection"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": assetPickerDialogAssetsPaginationQuery_graphql
    }
  },
  "name": "assetPickerDialogAssets_query",
  "selections": [
    {
      "alias": "aiAssetLibraryAssets",
      "args": [
        {
          "kind": "Variable",
          "name": "assetType",
          "variableName": "assetType"
        },
        {
          "kind": "Variable",
          "name": "categoryID",
          "variableName": "categoryID"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        },
        {
          "kind": "Variable",
          "name": "sortDirection",
          "variableName": "sortDirection"
        }
      ],
      "concreteType": "AiAssetLibraryAssetsConnection",
      "kind": "LinkedField",
      "name": "__assetPickerDialog_aiAssetLibraryAssets_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AiAssetLibraryAssetsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AIAssetLibraryAssetDTO",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnailUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "327224df4cc6458bb800e6fcb5feac08";

export default node;
